module.exports = __webpack_public_path__ + "img/01841_03_mobile.3f2a5c0d.png";